import React, { useState, useEffect } from "react";

export const svg = `<svg width="48" height="48" viewbox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M10.146 4.685c-.929 6.058 4.94 14.046 7.991 17.283-1.223.867-3.494 3.735-2.787 8.269.706 4.534 4.816 6.876 6.783 7.48l-1.812 5.482C17.608 36.21 9.155 33.195 5.268 32.559c-3.902-8.176-2.307-15.454-1.022-18.071 0 3.159 2.88 7.077 4.321 8.64.142-1.703-.01-2.178-.433-3.492a45.47 45.47 0 0 1-.775-2.64C6.29 12.909 8.69 7.412 10.146 4.687ZM32.42 19H37v8h7.72c1.257-5.776.092-10.51-.892-12.512 0 3.159-2.88 7.077-4.32 8.64-.142-1.703.01-2.178.432-3.492.2-.62.459-1.427.776-2.64 1.068-4.088-1.332-9.585-2.788-12.31.712 4.64-2.565 10.412-5.509 14.314ZM28 42.61v-5.833a9.842 9.842 0 0 1-2.058.94l1.812 5.482c.077-.2.16-.396.246-.588Z" fill="#A5584E"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M28 24.282a5.98 5.98 0 0 0-8 8.89V27h8v-2.718Z" fill="#9D48E0"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M43 34h-8v8h-5v-8h-8v-5h8v-8h5v8h8v5Z" fill="#E5EBEF"></path></svg>`;

const contentRegExp = /<svg(.*?)>(.*?)<\/svg>/s;
const attrRegExp = /(.*?)="(.*?)"/;
const splitAttrExp = /[\w-]+="[^"]*"/g;

const attributeMap = {
  viewbox: "viewBox",
  class: "className",
};

let instanceId = 0;

function Icon(props) {
  const [, attrs, content] = svg.match(contentRegExp);

  const svgAttributes = {};

  for (const stringAttr of attrs.trim().match(splitAttrExp)) {
    let [, key, value] = stringAttr.match(attrRegExp);
    if (key in attributeMap) key = attributeMap[key];
    svgAttributes[key] = value;
  }

  const [obj, setObj] = useState({ svgAttributes, __html: content });

  // On the client, unique IDs are necessary per instance.
  // We will use the fact that React SSR does not run effects!
  useEffect(() => {
    const ids = svg.matchAll(/id="(.*?)"/gm);
    let html = obj.__html;

    for (const [match, id] of ids) {
      const uniqueID = `${id}-${instanceId}`;
      html = html
        .replace(match, 'id="' + uniqueID + '"')
        .replaceAll(`url(#${id})`, `url(#${uniqueID})`)
        .replaceAll(`"#${id}"`, `"#${uniqueID}"`);
    }

    setObj({ svgAttributes, __html: html });

    instanceId++;
  }, []);

  return (
    <svg
      dangerouslySetInnerHTML={obj}
      {...obj.svgAttributes}
      {...props}
    />
  );
}

export default Object.assign(Icon, { svg });
